import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, register } from '../services/api';

const AuthPage = ({ onLoginSuccess }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    password: '', 
    confirmPassword: '' 
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        // --- LOGIQUE CONNEXION ---
        const res = await login({ 
            email: formData.email, 
            password: formData.password 
        });

        // 1. On logue pour vérifier si l'ID est bien présent (Grâce à la modif auth.js backend)
        console.log("Données reçues du serveur au login:", res.data);

        // 2. SAUVEGARDE IMPÉRATIVE dans le localStorage
        // Cela permet au ChatModule de retrouver l'ID même après un F5
        localStorage.setItem('user', JSON.stringify(res.data));

        // 3. Mise à jour du state global dans App.js
        onLoginSuccess(res.data);

        // 4. Redirection
        navigate('/');
      } else {
        // --- LOGIQUE INSCRIPTION ---
        if (formData.password !== formData.confirmPassword) {
          setLoading(false);
          return alert("Les mots de passe ne correspondent pas");
        }

        const signupData = {
          username: formData.name, 
          email: formData.email,
          password: formData.password,
          role: 'Auditeur' 
        };

        await register(signupData);
        alert("Compte créé avec succès ! Connectez-vous maintenant.");
        setIsLogin(true); 
      }
    } catch (err) {
      console.error("Erreur Auth:", err.response?.data);
      alert(err.response?.data?.error || "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center p-3" style={{ background: '#0f172a' }}>
      <div className="bg-white rounded-4 shadow-lg overflow-hidden d-flex flex-column flex-md-row" style={{ maxWidth: '850px', width: '100%' }}>
        
        {/* Sidebar Visuelle */}
        <div className="p-5 text-white d-none d-md-flex flex-column justify-content-center align-items-center text-center" 
             style={{ width: '40%', background: 'linear-gradient(135deg, #002d5b 0%, #004a99 100%)' }}>
          <h2 className="fw-black italic text-uppercase h1">Fréquence<span className="text-danger">974</span></h2>
          <p className="small opacity-75 mt-3">L'intensité de l'océan indien</p>
          <i className={`bi ${isLogin ? 'bi-shield-lock' : 'bi-person-plus'} display-1 mt-4 opacity-25`}></i>
        </div>

        {/* Section Formulaire */}
        <div className="p-4 p-md-5 bg-white flex-grow-1">
          <div className="d-flex justify-content-center gap-4 mb-4">
            <button 
              type="button"
              onClick={() => setIsLogin(true)} 
              className={`btn p-0 fw-bold text-uppercase border-0 ${isLogin ? 'text-primary border-bottom border-primary border-3' : 'text-muted'}`}
              style={{ fontSize: '12px', borderRadius: 0 }}
            >
              Connexion
            </button>
            <button 
              type="button"
              onClick={() => setIsLogin(false)} 
              className={`btn p-0 fw-bold text-uppercase border-0 ${!isLogin ? 'text-primary border-bottom border-primary border-3' : 'text-muted'}`}
              style={{ fontSize: '12px', borderRadius: 0 }}
            >
              Inscription
            </button>
          </div>

          <h3 className="fw-black text-center text-uppercase mb-4" style={{ color: '#002d5b' }}>
            {isLogin ? 'Bon retour !' : 'Rejoindre la radio'}
          </h3>

          <form onSubmit={handleSubmit}>
            {!isLogin && (
              <div className="mb-3">
                <div className="input-group">
                  <span className="input-group-text bg-light border-0"><i className="bi bi-person text-muted"></i></span>
                  <input type="text" name="name" className="form-control bg-light border-0 p-3" placeholder="Nom complet ou Pseudo" onChange={handleChange} required />
                </div>
              </div>
            )}
            
            <div className="mb-3">
              <div className="input-group">
                <span className="input-group-text bg-light border-0"><i className="bi bi-envelope text-muted"></i></span>
                <input type="email" name="email" className="form-control bg-light border-0 p-3" placeholder="Email" onChange={handleChange} required />
              </div>
            </div>

            <div className="mb-3">
              <div className="input-group">
                <span className="input-group-text bg-light border-0"><i className="bi bi-key text-muted"></i></span>
                <input type="password" name="password" className="form-control bg-light border-0 p-3" placeholder="Mot de passe" onChange={handleChange} required />
              </div>
            </div>

            {!isLogin && (
              <div className="mb-4">
                <div className="input-group">
                  <span className="input-group-text bg-light border-0"><i className="bi bi-check-circle text-muted"></i></span>
                  <input type="password" name="confirmPassword" className="form-control bg-light border-0 p-3" placeholder="Confirmer le mot de passe" onChange={handleChange} required />
                </div>
              </div>
            )}

            <button type="submit" disabled={loading} className="btn btn-primary w-100 py-3 rounded-pill fw-bold text-uppercase shadow-sm">
              {loading ? (
                <span className="spinner-border spinner-border-sm me-2"></span>
              ) : (
                isLogin ? 'Se Connecter' : 'Créer mon compte'
              )}
            </button>
          </form>

          <div className="mt-4 text-center">
             <button onClick={() => navigate('/')} className="btn btn-link text-muted text-decoration-none small">
               <i className="bi bi-arrow-left me-1"></i> Retour à l'antenne
             </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;